<template>
  <section class="testimonials-section py-20">
    <v-container class="py-12">
      <div class="text-center" data-aos="fade-up">
        <div class="section-subtitle">
          <span
            v-for="(letter, index) in 'CLIENT TRUST'.split('')"
            :key="index"
            :style="{ animationDelay: `${index * 0.05}s` }"
            class="subtitle-letter"
          >
            {{ letter === " " ? "\u00A0" : letter }}
          </span>
        </div>

        <h2 class="section-title">
          <span class="subtitle-line"></span>

          <span class="title-word">What</span>
          <span class="title-word">Our</span>
          <span class="title-word">Clients</span>
          <span class="title-word">Say</span>
          <span class="subtitle-line"></span>
        </h2>
        <div class="title-underline"></div>
      </div>

      <div
        class="testimonials-slider"
        ref="slider"
        @mousedown="startDrag"
        @mousemove="onDrag"
        @mouseup="endDrag"
        @mouseleave="endDrag"
        @touchstart="startDrag"
        @touchmove="onDrag"
        @touchend="endDrag"
      >
        <div
          class="testimonials-track"
          :style="{ transform: `translateX(${translateX}px)` }"
        >
          <div
            v-for="(testimonial, index) in doubledTestimonials"
            :key="index"
            class="testimonial-card-wrapper"
            :style="{
              animationDelay: `${(index % currentTestimonials.length) * 0.1}s`,
            }"
          >
            <div
              class="testimonial-card"
              @mouseenter="handleCardHover(index)"
              @mouseleave="handleCardLeave(index)"
            >
              <div class="particle particle-1"></div>
              <div class="particle particle-2"></div>
              <div class="particle particle-3"></div>
              <div class="card-pattern pattern-dots"></div>
              <div class="card-pattern pattern-gradient"></div>
              <div class="card-pattern pattern-waves"></div>
              <div class="animated-border"></div>

              <div class="card-corner corner-top-right">
                <div class="corner-shine"></div>
              </div>
              <div class="card-corner corner-bottom-left">
                <div class="corner-shine"></div>
              </div>

              <div class="quote-icon">
                <svg width="40" height="32" viewBox="0 0 40 32" fill="none">
                  <path
                    d="M0 32V14.2222C0 6.35556 5.33333 0 16 0V5.33333C10.6667 5.33333 8 8 8 14.2222V16H16V32H0ZM24 32V14.2222C24 6.35556 29.3333 0 40 0V5.33333C34.6667 5.33333 32 8 32 14.2222V16H40V32H24Z"
                    fill="url(#quote-gradient)"
                  />
                  <defs>
                    <linearGradient
                      id="quote-gradient"
                      x1="0"
                      y1="0"
                      x2="40"
                      y2="32"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#f46523" stop-opacity="0.15" />
                      <stop
                        offset="1"
                        stop-color="#ff9800"
                        stop-opacity="0.05"
                      />
                    </linearGradient>
                  </defs>
                </svg>
              </div>

              <div class="rating-wrapper">
                <v-rating
                  :value="testimonial.rating"
                  color="#EFBF04"
                  readonly
                  dense
                  size="22"
                  class="mb-4 premium-rating"
                ></v-rating>
                <div class="rating-glow"></div>
              </div>

              <p class="testimonial-text">
                <span class="text-content">"{{ testimonial.text }}"</span>
              </p>

              <div class="d-flex align-center mt-auto client-info">
                <div class="avatar-container">
                  <v-avatar size="56" class="mr-4 avatar-gradient">
                    <span class="avatar-text">{{ testimonial.initial }}</span>
                  </v-avatar>
                  <div class="avatar-ring"></div>
                  <div class="avatar-pulse"></div>
                </div>
                <div class="client-details">
                  <div class="client-name">
                    <span
                      v-for="(char, i) in testimonial.name.split('')"
                      :key="i"
                      class="name-char"
                      :style="{ transitionDelay: `${i * 0.02}s` }"
                    >
                      {{ char }}
                    </span>
                  </div>
                  <div class="client-location">
                    <span class="location-icon">📍</span>
                    {{ testimonial.location }}
                  </div>
                </div>
              </div>

              <div class="card-shine"></div>
            </div>
          </div>
        </div>
      </div>
    </v-container>
    <div class="bg-decoration decoration-1"></div>
    <div class="bg-decoration decoration-2"></div>
    <div class="bg-decoration decoration-3"></div>
  </section>
</template>

<script>
export default {
  name: "TestimonialsContent",
  data() {
    return {
      isDragging: false,
      startX: 0,
      currentX: 0,
      velocity: 0,
      lastX: 0,
      translateX: 0,
      sliderWidth: 0,
      animationFrame: null,
      animateBound: null,
      currentDot: 0,
      testimonialsIndia: [
        {
          name: "Athira S",
          location: "Kochi",
          initial: "AS",
          rating: 5,
          text: "We had a sudden leak in the kitchen, and they came within an hour! Problem was fixed quickly, and the charges were reasonable. Highly recommend for emergency plumbing needs.",
        },
        {
          name: "Deepak Vasudev",
          location: "Bangalore",
          initial: "DV",
          rating: 4.5,
          text: "Always on time, friendly, and passionate about their work. My garden has never looked better, and I get compliments from all my neighbors!",
        },
        {
          name: "Aswani Vishnu",
          location: "Thrissur",
          initial: "AV",
          rating: 4.5,
          text: "I was worried about frequent power trips at home, but their electrician identified the problem in minutes and fixed it neatly. They explained everything clearly, which I really appreciated.",
        },
      ],
      testimonialsUSA: [
        {
          name: "William",
          location: "Chicago",
          rating: 4.5,

          text: "We had a sudden leak in the kitchen, and they came within an hour! Problem was fixed quickly, and the charges were reasonable. Highly recommend for emergency plumbing needs.",
        },
        {
          name: "Ezra",
          location: "New York",
          rating: 5,

          text: "Always on time, friendly, and passionate about their work. My garden has never looked better, and I get compliments from all my neighbors!",
        },
        {
          name: "Noah",
          location: "San fransisco",
          rating: 4.5,

          text: "I was worried about frequent power trips at home, but their electrician identified the problem in minutes and fixed it neatly. They explained everything clearly, which I really appreciated.",
        },
      ],
    };
  },
  computed: {
    currentLocation() {
      // Read location from route meta
      return (
        (this.$route && this.$route.meta && this.$route.meta.location) ||
        "india" // default to India
      );
    },
    currentTestimonials() {
      // Changed from "usa" to "us" to match your route meta
      if (this.currentLocation === "us") return this.testimonialsUSA;
      // default to India testimonials
      return this.testimonialsIndia;
    },
    // doubled list for infinite-like scrolling
    doubledTestimonials() {
      return [...this.currentTestimonials, ...this.currentTestimonials];
    },
  },

  watch: {
    // when route location changes, reset slider and recalc widths
    currentLocation() {
      this.translateX = 0;
      this.currentDot = 0;
      this.$nextTick(() => {
        this.sliderWidth = this.$refs.slider
          ? this.$refs.slider.scrollWidth / 2
          : 0;
        this.updateCurrentDot();
      });
    },
    currentTestimonials() {
      // testimonials changed (maybe route or dynamic update) -> recalc
      this.$nextTick(() => {
        this.sliderWidth = this.$refs.slider
          ? this.$refs.slider.scrollWidth / 2
          : 0;
        this.updateCurrentDot();
      });
    },
  },
  mounted() {
    // bind animate so we can cancel later
    this._animateBound = this.animate.bind(this);
    this.sliderWidth = this.$refs.slider
      ? this.$refs.slider.scrollWidth / 2
      : 0;
    // start the loop
    this.animationFrame = requestAnimationFrame(this._animateBound);
    this.updateCurrentDot();
  },
  beforeDestroy() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
  },
  methods: {
    // helper to extract pageX reliably for mouse & touch events
    _getPageX(e) {
      if (!e) return 0;
      if (e.type && e.type.startsWith("touch")) {
        if (e.touches && e.touches[0]) return e.touches[0].pageX;
        if (e.changedTouches && e.changedTouches[0])
          return e.changedTouches[0].pageX;
        return 0;
      }
      return e.pageX !== undefined ? e.pageX : e.clientX || 0;
    },

    startDrag(e) {
      // stop auto animation while user interacts
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }
      this.isDragging = true;
      const pageX = this._getPageX(e);
      this.startX = pageX;
      this.lastX = pageX;
      this.velocity = 0;
    },

    onDrag(e) {
      if (!this.isDragging) return;
      const pageX = this._getPageX(e);
      const delta = pageX - this.lastX;
      this.translateX += delta;
      this.lastX = pageX;
      this.velocity = delta;
      this.updateCurrentDot();
    },

    endDrag() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.momentumScroll();
    },

    momentumScroll() {
      const friction = 0.95;
      const step = () => {
        this.translateX += this.velocity;
        this.velocity *= friction;

        // wrap-around logic for continuous effect
        if (this.sliderWidth && this.translateX < -this.sliderWidth) {
          this.translateX = 0;
        }
        if (this.sliderWidth && this.translateX > 0) {
          this.translateX = -this.sliderWidth;
        }

        this.updateCurrentDot();

        if (Math.abs(this.velocity) > 0.3) {
          this.animationFrame = requestAnimationFrame(step);
        } else {
          // resume the continuous auto animation
          this.animationFrame = requestAnimationFrame(this._animateBound);
        }
      };
      this.animationFrame = requestAnimationFrame(step);
    },

    animate() {
      // automatic slow left scroll when not interacting
      if (!this.isDragging) {
        this.translateX -= 0.3;
        if (this.sliderWidth && this.translateX < -this.sliderWidth) {
          this.translateX = 0;
        }
        this.updateCurrentDot();
      }
      // schedule next frame
      this.animationFrame = requestAnimationFrame(this._animateBound);
    },

    updateCurrentDot() {
      // find card width from DOM (fallback to 488)
      let cardWidth = 488;
      try {
        const slider = this.$refs.slider;
        if (slider && slider.querySelector) {
          const wrapper = slider.querySelector(".testimonial-card-wrapper");
          if (wrapper && wrapper.offsetWidth) {
            cardWidth = wrapper.offsetWidth;
          }
        }
      } catch (err) {
        // ignore and use fallback
      }

      const len =
        (this.currentTestimonials && this.currentTestimonials.length) || 1;
      const absTranslate = Math.abs(this.translateX || 0);
      const rawIndex = Math.floor(absTranslate / cardWidth);
      const idx = rawIndex % len;
      this.currentDot = idx;
    },

    handleCardHover() {
      // Optional: Add hover effects
    },

    handleCardLeave() {
      // Optional: Remove hover effects
    },
  },
};
</script>

<style scoped>
:root {
  --primary-color: #f46523;
  --secondary-color: #ff9800;
  --text-dark: #1a1a1a;
  --text-light: #666;
}

.testimonials-section {
  position: relative;
  background: white !important;

  overflow: hidden;
  user-select: none;
}

.bg-decoration {
  position: absolute;
  border-radius: 50%;
  opacity: 0.03;
  pointer-events: none;
  animation: floatAnimation 20s infinite ease-in-out;
}

.decoration-1 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, var(--primary-color), transparent);
  top: -100px;
  right: -100px;
  animation-delay: 0s;
}

.decoration-2 {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, var(--secondary-color), transparent);
  bottom: -50px;
  left: -50px;
  animation-delay: 5s;
}

.decoration-3 {
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, var(--primary-color), transparent);
  top: 50%;
  left: 50%;
  animation-delay: 10s;
}

@keyframes floatAnimation {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  25% {
    transform: translate(30px, -30px) scale(1.1);
  }
  50% {
    transform: translate(-20px, 20px) scale(0.9);
  }
  75% {
    transform: translate(20px, 30px) scale(1.05);
  }
}

.section-subtitle {
  color: white;
  font-weight: 800;
  letter-spacing: 5px;
  font-size: 13px;
  text-transform: uppercase;
  margin-bottom: 16px;
  margin-top: 12px;
  display: inline-block;
}

.subtitle-letter {
  display: inline-block;
  animation: letterBounce 0.6s ease-out forwards;
  opacity: 0;
  color: #000;
  transform: translateY(-20px);
}

@keyframes letterBounce {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  50% {
    transform: translateY(5px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.section-title {
  font-size: clamp(2.2rem, 4.5vw, 3.2rem);
  font-weight: 900;
  color: #f46523;
  line-height: 1.1;
  margin-bottom: 20px;
}

.title-word {
  display: inline-block;
  margin: 0 8px;
  animation: titleSlideIn 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) backwards;
  background: #f46523;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.title-word:nth-child(1) {
  animation-delay: 0.1s;
}
.title-word:nth-child(2) {
  animation-delay: 0.2s;
}
.title-word:nth-child(3) {
  animation-delay: 0.3s;
}
.title-word:nth-child(4) {
  animation-delay: 0.4s;
}

@keyframes titleSlideIn {
  from {
    opacity: 0;
    transform: translateY(30px) rotateX(-90deg);
  }
  to {
    opacity: 1;
    transform: translateY(0) rotateX(0);
  }
}

.title-underline {
  width: 80px;
  height: 4px;
  background: linear-gradient(
    90deg,
    var(--primary-color),
    var(--secondary-color)
  );
  margin: 0 auto;
  border-radius: 2px;
  animation: underlineExpand 1s ease-out 0.5s backwards;
  position: relative;
}

.title-underline::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    var(--secondary-color),
    var(--primary-color)
  );
  border-radius: 2px;
  animation: underlineShine 2s infinite;
}

@keyframes underlineExpand {
  from {
    width: 0;
    opacity: 0;
  }
  to {
    width: 80px;
    opacity: 1;
  }
}

@keyframes underlineShine {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

/* Slider */
.testimonials-slider {
  overflow: hidden;
  position: relative;
  padding: 2rem 0;
  cursor: grab;
}

.testimonials-slider:active {
  cursor: grabbing;
}

.testimonials-track {
  display: flex;
  gap: 28px;
  transition: transform 0.2s ease-out;
}

.testimonial-card-wrapper {
  flex: 0 0 auto;
  width: 460px;
  animation: cardFadeIn 0.8s ease-out backwards;
}

@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.testimonial-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 32px 36px;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 10px 40px rgba(244, 101, 35, 0.08),
    0 0 0 1px rgba(244, 101, 35, 0.05) inset;
  border: 1px solid rgba(244, 101, 35, 0.1);
  backdrop-filter: blur(10px);
  transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  cursor: pointer;
  overflow: hidden;
  transform-style: preserve-3d;
}

.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: var(--primary-color);
  border-radius: 50%;
  opacity: 0;
  animation: particleFloat 3s infinite ease-in-out;
}

.particle-1 {
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.particle-2 {
  top: 60%;
  right: 15%;
  animation-delay: 1s;
}

.particle-3 {
  bottom: 30%;
  left: 20%;
  animation-delay: 2s;
}

@keyframes particleFloat {
  0%,
  100% {
    opacity: 0;
    transform: translateY(0) scale(0);
  }
  50% {
    opacity: 0.6;
    transform: translateY(-30px) scale(1);
  }
}

.testimonial-card:hover .particle {
  animation-duration: 2s;
}

.card-pattern {
  position: absolute;
  transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
  pointer-events: none;
}

.pattern-dots {
  top: -30px;
  right: -30px;
  width: 140px;
  height: 140px;
  background-image: radial-gradient(
    circle,
    rgba(244, 101, 35, 0.12) 2px,
    transparent 2px
  );
  background-size: 16px 16px;
  opacity: 0.4;
  z-index: 0;
}

.pattern-gradient {
  bottom: -50px;
  left: -50px;
  width: 180px;
  height: 180px;
  background: radial-gradient(
    circle,
    rgba(255, 152, 0, 0.15) 0%,
    transparent 70%
  );
  opacity: 0.5;
  z-index: 0;
}

.pattern-waves {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200%;
  height: 200%;
  background: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 10px,
    rgba(244, 101, 35, 0.02) 10px,
    rgba(244, 101, 35, 0.02) 20px
  );
  transform: translate(-50%, -50%) rotate(0deg);
  opacity: 0;
  transition: all 0.8s ease;
  z-index: 0;
}

.animated-border {
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 20px;
  background: linear-gradient(
    45deg,
    var(--primary-color),
    var(--secondary-color),
    var(--primary-color)
  );
  background-size: 300% 300%;
  opacity: 0;
  z-index: -1;
  animation: gradientRotate 3s ease infinite;
}

@keyframes gradientRotate {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.card-corner {
  position: absolute;
  width: 60px;
  height: 60px;
  transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  z-index: 1;
  overflow: hidden;
}

.corner-top-right {
  top: 0;
  right: 0;
  border-top: 3px solid #f46523;
  border-right: 3px solid #f46523;
  border-top-right-radius: 20px;
}

.corner-bottom-left {
  bottom: 0;
  left: 0;
  border-bottom: 3px solid #f46523;
  border-left: 3px solid #f46523;
  border-bottom-left-radius: 20px;
}

.corner-shine {
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, transparent, rgba(255, 255, 255, 0.4));
  opacity: 0;
  transition: opacity 0.4s ease;
}

.corner-top-right .corner-shine {
  top: -100%;
  right: -100%;
}

.corner-bottom-left .corner-shine {
  bottom: -100%;
  left: -100%;
}

.quote-icon {
  position: absolute;
  top: 24px;
  right: 24px;
  opacity: 0.6;
  transition: all 0.5s ease;
  z-index: 1;
  animation: quoteFloat 3s ease-in-out infinite;
}

@keyframes quoteFloat {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-8px);
  }
}

.rating-wrapper {
  position: relative;
  z-index: 2;
}

.rating-glow {
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  background: radial-gradient(circle, rgba(239, 191, 4, 0.3), transparent);
  opacity: 0;
  transition: opacity 0.4s ease;
  border-radius: 8px;
  z-index: -1;
}

:deep(.premium-rating .v-icon) {
  filter: drop-shadow(0 2px 4px rgba(239, 191, 4, 0.3));
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
}

.testimonial-text {
  color: var(--text-dark);
  line-height: 1.7;
  font-size: 14.5px;
  font-weight: 500;
  flex-grow: 1;
  margin-bottom: 20px;
  padding-top: 10px;
  position: relative;
  z-index: 2;
}

.text-content {
  display: block;
  transition: all 0.4s ease;
}

.client-info {
  position: relative;
  z-index: 2;
}

.avatar-container {
  position: relative;
  margin-right: 16px;
}

.avatar-gradient {
  background: #f46523;
  box-shadow: 0 8px 20px rgba(244, 101, 35, 0.4);
  transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  z-index: 3;
}

.avatar-text {
  transition: all 0.4s ease;
  color: white;
}

.avatar-ring {
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border: 2px solid var(--primary-color);
  border-radius: 50%;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  z-index: 2;
}

.avatar-pulse {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(244, 101, 35, 0.4), transparent);
  transform: translate(-50%, -50%) scale(1);
  opacity: 0;
  z-index: 1;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.3);
    opacity: 0.5;
  }
}

.client-details {
  flex: 1;
}

.client-name {
  font-weight: 700;
  font-size: 16.5px;
  color: var(--text-dark);
  line-height: 1.3;
  margin-bottom: 4px;
}

.name-char {
  display: inline-block;
  transition: all 0.3s ease;
}

.client-location {
  font-weight: 500;
  font-size: 13.5px;
  color: var(--text-light);
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.3s ease;
}

.location-icon {
  display: inline-block;
  transition: all 0.3s ease;
  font-size: 12px;
}

.card-shine {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent 30%,
    rgba(255, 255, 255, 0.3) 50%,
    transparent 70%
  );
  transform: translateX(-100%) translateY(-100%) rotate(45deg);
  transition: transform 0.8s ease;
  pointer-events: none;
  z-index: 10;
}

.testimonial-card:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 25px 60px rgba(244, 101, 35, 0.25),
    0 0 0 1px rgba(244, 101, 35, 0.2) inset, 0 0 40px rgba(244, 101, 35, 0.15);
  border-color: transparent;
}

.testimonial-card:hover .animated-border {
  opacity: 1;
}

.testimonial-card:hover .pattern-dots {
  opacity: 0.8;
  transform: rotate(15deg) scale(1.1);
}

.testimonial-card:hover .pattern-gradient {
  opacity: 0.9;
  transform: scale(1.2);
}

.testimonial-card:hover .pattern-waves {
  opacity: 1;
  transform: translate(-50%, -50%) rotate(5deg);
}

.testimonial-card:hover .corner-top-right {
  transform: translate(6px, -6px);
}

.testimonial-card:hover .corner-bottom-left {
  transform: translate(-6px, 6px);
}

.testimonial-card:hover .corner-shine {
  opacity: 1;
}

.testimonial-card:hover .quote-icon {
  opacity: 1;
  transform: translateY(-4px) scale(1.1);
}

.testimonial-card:hover .rating-glow {
  opacity: 1;
}

.testimonial-card:hover :deep(.premium-rating .v-icon) {
  transform: scale(1.15) rotate(10deg);
  filter: drop-shadow(0 4px 8px rgba(239, 191, 4, 0.5));
}

.testimonial-card:hover .text-content {
  transform: translateX(3px);
}

.testimonial-card:hover .avatar-gradient {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 12px 28px rgba(244, 101, 35, 0.6);
}

.testimonial-card:hover .avatar-text {
  transform: scale(1.1);
}

.testimonial-card:hover .avatar-ring {
  opacity: 1;
  transform: scale(1.1);
}

.testimonial-card:hover .name-char {
  transform: translateY(-2px);
  color: var(--primary-color);
}

.testimonial-card:hover .location-icon {
  transform: scale(1.2);
  animation: locationBounce 0.6s ease;
}

@keyframes locationBounce {
  0%,
  100% {
    transform: scale(1.2) translateY(0);
  }
  50% {
    transform: scale(1.2) translateY(-4px);
  }
}

.testimonial-card:hover .card-shine {
  transform: translateX(100%) translateY(100%) rotate(45deg);
}

.slider-controls {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.control-dots {
  display: flex;
  gap: 12px;
  align-items: center;
}

.control-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(244, 101, 35, 0.2);
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.control-dot::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: var(--primary-color);
  transform: translate(-50%, -50%);
  transition: all 0.4s ease;
}

.control-dot.active {
  width: 32px;
  border-radius: 5px;
  background: var(--primary-color);
  box-shadow: 0 4px 12px rgba(244, 101, 35, 0.4);
}

.control-dot.active::before {
  width: 100%;
  height: 100%;
  animation: dotPulse 1.5s infinite;
}

@keyframes dotPulse {
  0%,
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.5;
    transform: translate(-50%, -50%) scale(1.5);
  }
}

.control-dot:hover:not(.active) {
  background: rgba(244, 101, 35, 0.4);
  transform: scale(1.2);
}

@media (max-width: 960px) {
  .testimonial-card-wrapper {
    width: 380px;
  }

  .testimonial-card {
    height: 280px;
    padding: 28px 30px;
  }

  .section-title {
    font-size: 2rem;
  }

  .pattern-dots {
    width: 110px;
    height: 110px;
  }

  .pattern-gradient {
    width: 140px;
    height: 140px;
  }

  .quote-icon svg {
    width: 32px;
    height: 26px;
  }

  .card-corner {
    width: 50px;
    height: 50px;
  }
}

@media (max-width: 600px) {
  .testimonial-card-wrapper {
    width: 320px;
  }

  .testimonial-card {
    padding: 28px 26px;
    height: 320px;
  }

  .testimonial-text {
    font-size: 14px;
    line-height: 1.65;
    margin-bottom: 22px;
  }

  .card-corner {
    width: 45px;
    height: 45px;
  }

  .quote-icon {
    top: 20px;
    right: 20px;
  }

  .quote-icon svg {
    width: 28px;
    height: 22px;
  }

  .avatar-gradient {
    width: 52px;
    height: 52px;
  }

  .client-name {
    font-size: 15.5px;
  }

  .client-location {
    font-size: 13px;
  }

  .section-subtitle {
    font-size: 12px;
    letter-spacing: 4px;
  }

  .title-word {
    margin: 0 4px;
  }

  .pattern-dots {
    width: 90px;
    height: 90px;
    background-size: 12px 12px;
  }

  .pattern-gradient {
    width: 120px;
    height: 120px;
  }

  .bg-decoration {
    opacity: 0.02;
  }

  .decoration-1 {
    width: 300px;
    height: 300px;
  }

  .decoration-2 {
    width: 220px;
    height: 220px;
  }

  .decoration-3 {
    width: 180px;
    height: 180px;
  }
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

@keyframes rotate360 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.testimonials-track {
  will-change: transform;
}

.testimonial-card {
  will-change: transform, box-shadow;
}

.testimonial-card,
.card-pattern,
.avatar-gradient,
.control-dot {
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

.testimonial-card:focus-visible {
  outline: 3px solid var(--primary-color);
  outline-offset: 4px;
}

.control-dot:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 3px;
}

@media print {
  .testimonials-section {
    background: white;
  }

  .bg-decoration,
  .particle,
  .card-shine,
  .animated-border {
    display: none;
  }

  .testimonial-card {
    box-shadow: none;
    border: 1px solid #ccc;
    page-break-inside: avoid;
  }
}
.subtitle-line {
  width: 40px;
  height: 2px;
  margin-bottom: 12px;
  background: linear-gradient(90deg, transparent, #f46523, transparent);
  display: inline-block;
  animation: lineGrow 2s infinite ease-in-out;
}
</style>
